import React, { useState, useEffect } from "react";
import { Container, Row, col } from "react-bootstrap";
import classes from "./StudentDetails.module.css";
import { Button } from "../../../../stories/Button/Button";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import {
  coachDemoImg,
  chatSendIcon,
  ChatBlackIcon,
  LocationIconGray,
  CoachHatIcon,
  CancelIconBlack,
} from "../../../../constant/imagePath";
import Ratings from "react-star-ratings";
import { ReactSVG } from "react-svg";

const StudentDetails = ({ studentDetails, toggleDrawer }) => {
  return (
    <div className={[classes.studentDetailsScreen].join(" ")}>
      <ReactSVG
        src={CancelIconBlack}
        className={[classes.cancel].join(" ")}
        onClick={toggleDrawer}
      />
      <div
        style={{ borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}` }}
        className={[classes.header].join(" ")}
      >
        <div className={[classes.dflex].join(" ")}>
          <div className={[classes.studentImg].join(" ")}>
            <img src={studentDetails?.img} alt="..." />
          </div>
          <div className={[classes.headerContent].join(" ")}>
            <p
              style={{
                ...Fonts.h4,
                color: Colors.neutralShadesOfNero,
                fontSize: "26px",
              }}
              className={[classes.mb10].join(" ")}
            >
              {studentDetails?.name}
            </p>
            <div className={[classes.starDiv].join(" ")}>
              <div className={[classes.starInStudentDetails].join(" ")}>
                <Ratings
                  numberOfStars={1}
                  rating={studentDetails?.rating}
                  starRatedColor={Colors.mainShadeOfRed}
                  starEmptyColor={Colors.neutralShadesOfGainsboro}
                  starDimension="16px"
                />
              </div>
              <p
                style={{
                  ...Fonts.h8,
                  fontSize: "14px",
                  color: Colors.neutralShadesOfNero,
                }}
                className={[classes.ml8].join(" ")}
              >
                {studentDetails?.rating.toFixed(1)}
              </p>
              <span
                style={{ backgroundColor: Colors.neutralShadesOfPinkSwan }}
                className={[classes.dot].join(" ")}
              />
              <p
                style={{
                  ...Fonts.h8,
                  fontSize: "14px",
                  color: Colors.neutralShadesOfNero,
                }}
              >
                {studentDetails?.age} years old
              </p>
            </div>
          </div>
        </div>
        <div>
          <Button label="" primary={false} icon={ChatBlackIcon} />
        </div>
      </div>
      <div
        style={{ borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}` }}
        className={[classes.aboutDiv].join(" ")}
      >
        <p
          style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
          className={[classes.pb24].join(" ")}
        >
          More About {studentDetails?.name.split(" ")[0]}
        </p>
        <p
          style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
          className={[classes.pb24].join(" ")}
        >
          {studentDetails?.aboutMe}
        </p>
      </div>
      <div
        style={{ borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}` }}
        className={[classes.aboutDiv].join(" ")}
      >
        <p
          style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
          className={[classes.pb24].join(" ")}
        >
          Experience
        </p>
        <div className={[classes.dflex].join(" ")}>
          {studentDetails?.experience.map((item, i) => {
            return (
              <div
                className={[classes.experienceBox].join(" ")}
                key={i}
                style={{
                  border: `1px solid ${Colors.neutralShadesOfWhisper}`,
                }}
              >
                <span
                  style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
                >
                  {item?.title}:
                </span>
                <span
                  style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}
                  className={[classes.pl1].join(" ")}
                >
                  {item?.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      {studentDetails?.myCoaches.length > 0 ? (
        <div className={[classes.coachMainDiv].join(" ")}>
          <p
            style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
            className={[classes.pb24].join(" ")}
          >
            My Coaches
          </p>
          {studentDetails?.myCoaches.map((item, i) => {
            return (
              <div
                className={[classes.coachDiv].join(" ")}
                key={i}
                style={{
                  borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                }}
              >
                <div className={[classes.studentImg].join(" ")}>
                  <img src={item?.img} alt="..." />
                </div>
                <div
                  className={[classes.pl16, classes.coachMainContentDiv].join(
                    " "
                  )}
                >
                  <div>
                    <p
                      style={{
                        ...Fonts.h5,
                        color: Colors.neutralShadesOfNero,
                      }}
                      className={[classes.mb8].join(" ")}
                    >
                      {studentDetails?.name}
                    </p>
                    <div className={[classes.coachDetailDiv].join(" ")}>
                      <div
                        style={{
                          ...Fonts.p2,
                          color: Colors.neutralShadesOfDimGray,
                        }}
                        className={[classes.locationIconDiv].join(" ")}
                      >
                        <ReactSVG src={LocationIconGray} />
                        <span className={[classes.ml6].join(" ")}>
                          {item?.location}
                        </span>
                      </div>
                      <span
                        style={{
                          backgroundColor: Colors.neutralShadesOfDimGray,
                        }}
                        className={[classes.coachDot].join(" ")}
                      />
                      <p
                        style={{
                          ...Fonts.p2,
                          color: Colors.neutralShadesOfDimGray,
                        }}
                      >
                        {item?.sport}
                      </p>
                    </div>
                  </div>
                  <div className={[classes.coachRatingDiv].join(" ")}>
                    <Ratings
                      numberOfStars={1}
                      rating={item?.rating}
                      starRatedColor={Colors.mainShadeOfRed}
                      starEmptyColor={Colors.neutralShadesOfGainsboro}
                      starDimension="16px"
                    />
                    <p
                      style={{
                        ...Fonts.h7,
                        fontSize: "16px",
                        color: Colors.neutralShadesOfNero,
                      }}
                      className={[classes.ml4].join(" ")}
                    >
                      {item?.rating.toFixed(1)}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div
          style={{ border: `1px solid ${Colors.neutralShadesOfWhisper}` }}
          className={[classes.noCoachesDiv].join(" ")}
        >
          <ReactSVG
            className={[classes.CoachHatImg].join(" ")}
            src={CoachHatIcon}
          />
          <p
            className={[classes.mb16].join(" ")}
            style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
          >
            {studentDetails?.name} has no coaches yet
          </p>
          <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
            As soon as the student passes the first training session, the coach
            from whom she passed it will appear here.
          </p>
        </div>
      )}
    </div>
  );
};

export default StudentDetails;
